import {
  Badge,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { Guest } from 'services/@types';

const rsvpColorMap: Record<string, string> = {
  attending: 'green',
  declined: 'red',
  pending: 'orange',
  new: 'blue',
  checkedIn: 'teal',
};

interface GuestListTableProps {
  guests: Guest[];
}

export default function GuestListTable({ guests }: GuestListTableProps) {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  return (
    <Card p="30px">
      <Text color={textColor} fontSize="xl" fontWeight="700" mb="20px">
        Guest List ({guests.length})
      </Text>
      {guests.length === 0 ? (
        <Text color="gray.500" fontSize="sm">
          No guests found
        </Text>
      ) : (
        <Table variant="simple" size="sm">
          <Thead>
            <Tr>
              <Th borderColor={borderColor}>Name</Th>
              <Th borderColor={borderColor}>Email</Th>
              <Th borderColor={borderColor}>Phone</Th>
              <Th borderColor={borderColor}>RSVP</Th>
              <Th borderColor={borderColor}>Adults</Th>
              <Th borderColor={borderColor}>Children</Th>
              <Th borderColor={borderColor}>Group</Th>
              <Th borderColor={borderColor}>Side</Th>
            </Tr>
          </Thead>
          <Tbody>
            {guests.map((guest) => (
              <Tr key={guest.id}>
                <Td borderColor={borderColor}>
                  <Text color={textColor} fontSize="sm" fontWeight="500">
                    {guest.firstName} {guest.lastName}
                  </Text>
                </Td>
                <Td borderColor={borderColor}>
                  <Text color={textColor} fontSize="sm">
                    {guest.email || '-'}
                  </Text>
                </Td>
                <Td borderColor={borderColor}>
                  <Text color={textColor} fontSize="sm">
                    {guest.phone || '-'}
                  </Text>
                </Td>
                <Td borderColor={borderColor}>
                  <Badge
                    colorScheme={
                      rsvpColorMap[guest.rsvpStatus || ''] || 'gray'
                    }
                    fontSize="xs"
                    borderRadius="6px"
                  >
                    {guest.rsvpStatus || '-'}
                  </Badge>
                </Td>
                <Td borderColor={borderColor}>
                  <Text color={textColor} fontSize="sm">
                    {guest.adults ?? '-'}
                  </Text>
                </Td>
                <Td borderColor={borderColor}>
                  <Text color={textColor} fontSize="sm">
                    {guest.children ?? '-'}
                  </Text>
                </Td>
                <Td borderColor={borderColor}>
                  <Text color={textColor} fontSize="sm">
                    {guest.group || '-'}
                  </Text>
                </Td>
                <Td borderColor={borderColor}>
                  <Text color={textColor} fontSize="sm">
                    {guest.side || '-'}
                  </Text>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </Card>
  );
}
